import React, { createContext } from 'react';
import { rootStore } from '../../stores/index';

export const StoreContext = createContext(null);
// PageContext теперь в отдельном файле
export { PageContext } from './PageContext';

export const StoreProvider = ({ children }) => {
    return (
        <StoreContext.Provider value={rootStore}>
            {children}
        </StoreContext.Provider>
    );
};